<template>
  <zm-popover v-if="data.length > 1" placement="top-start" trigger="click">
    <div class="table-column-list-popover-tag-list-wrap">
      <zm-tag size="small" v-for="item in data" :key="item">
        {{ item }}
      </zm-tag>
    </div>
    <div slot="reference">
      <zm-tag size="small" v-if="firstTag"> {{ firstTag }} </zm-tag>
      <span class="table-column-list-popover__more-text"
        >+{{ data.length - 1 }}</span
      >
    </div>
  </zm-popover>
  <zm-tag v-else size="small"> {{ firstTag }} </zm-tag>
</template>

<script>
export default {
  name: 'ASTableColumnListPopover',
  props: ['data'],
  computed: {
    firstTag() {
      if (this.data.length === 0) {
        return ''
      }
      return this.data[0]
    },
  },
}
</script>

<style scoped lang="scss">
.table-column-list-popover__more-text {
  margin-left: 10px;
  color: #0956b5;
}
.table-column-list-popover-tag-list-wrap {
  max-height: 600px;
  overflow-y: auto;
  > span.zm-tag {
    display: block;
    margin: 10px 0;
  }
}
</style>
